import {inject, Injectable} from '@angular/core';
import {SnackbarService} from "../../../../../core/services/snackbar.service";
import {CombineFilesParams, ValidateAndFilterFilesParams} from "../types/delayed-file-upload-card.types";
import {notificationTexts} from "../configs/delayed-file-upload-card-config";

@Injectable({
  providedIn: 'root'
})
export class DelayedFileUploadCardService {
  private snackbarService: SnackbarService = inject(SnackbarService);

  public validateAndFilterFiles(validateAndFilterFilesParams: ValidateAndFilterFilesParams): Array<File> {
    const { allowedExtensions, files, isMultiple, selectedFiles } = validateAndFilterFilesParams;
    const allowedFiles = this.filterAllowedFiles(validateAndFilterFilesParams);

    if (!allowedFiles.length) {
      this.showNoAllowedExtensionsError(allowedExtensions);
      return [];
    }

    if (allowedFiles.length < files.length) { this.showSomeFilesFilteredInfo(); }

    return this.combineFiles({
      isMultiple: isMultiple,
      selectedFiles: selectedFiles,
      allowedFiles: allowedFiles
    });
  }

  private filterAllowedFiles({ allowedExtensions, files }: ValidateAndFilterFilesParams): Array<File> {
    if (!allowedExtensions.length) { return files; }

    return files.filter(file => {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      return allowedExtensions.includes(fileExtension || '');
    });
  }

  private showNoAllowedExtensionsError(allowedExtensions: ReadonlyArray<string>): void {
    const extensionsText = allowedExtensions.map(ext => `.${ext}`).join(', ');
    this.snackbarService.showMessage({
      message: notificationTexts.NO_ALLOWED_EXTENSIONS(extensionsText),
      type: 'error'
    });
  }

  private showSomeFilesFilteredInfo(): void {
    this.snackbarService.showMessage({
      message: notificationTexts.SOME_FILES_FILTERED,
      type: 'info'
    });
  }

  private combineFiles({ isMultiple, selectedFiles, allowedFiles }: CombineFilesParams): Array<File> {
    return isMultiple ?
      [ ...selectedFiles, ...allowedFiles ] :
      [ allowedFiles[0] ];
  }
}
